"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTCard = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Card_1 = require("../Card/Card");
var Popup_1 = require("../Popup/Popup");
var Mana_1 = require("../Mana/Mana");
var NFTImage_1 = require("../NFTImage");
var utils_1 = require("./utils");
require("./NFTCard.css");
var NFTCard = function (props) {
    var nft = props.nft, i18n = props.i18n, header = props.header, subtitle = props.subtitle, badges = props.badges, price = props.price, className = props.className, cardProps = __rest(props, ["nft", "i18n", "header", "subtitle", "badges", "price", "className"]);
    var renderHeader = (0, react_1.useCallback)(function () {
        if (!header || typeof header === 'string') {
            return (react_1.default.createElement("div", { className: "dui-nft-card__header" },
                react_1.default.createElement("span", { className: "dui-nft-card__title" }, header || nft.name),
                price && (react_1.default.createElement(Mana_1.Mana, { network: nft.network, inline: true, className: "dui-nft-card__price" }, price))));
        }
        return header;
    }, [header]);
    var renderSubtitle = (0, react_1.useCallback)(function () {
        if (!subtitle || typeof subtitle === 'string') {
            return (react_1.default.createElement("span", { className: "dui-nft-card__subtitle" }, subtitle || (0, utils_1.getSubtitle)(nft, i18n)));
        }
        return subtitle;
    }, [subtitle]);
    var renderBadge = (0, react_1.useCallback)(function (badge) {
        if (badge.icon && badge.hideLabel) {
            return (react_1.default.createElement(Popup_1.Popup, { key: badge.label, content: badge.label, trigger: react_1.default.createElement("span", { className: "dui-nft-card__badge--only-icon", style: { background: badge.color } },
                    react_1.default.createElement("i", { className: (0, classnames_1.default)('dui-nft-card__badge-icon', badge.icon), "aria-label": badge.label })) }));
        }
        return (react_1.default.createElement("span", { className: "dui-nft-card__badge", style: { background: badge.color }, key: badge.label },
            badge.icon && (react_1.default.createElement("i", { className: (0, classnames_1.default)('dui-nft-card__badge-icon', badge.icon) })),
            badge.label));
    }, []);
    var renderBadges = (0, react_1.useCallback)(function () {
        if (badges) {
            return badges;
        }
        var nftBadges = (0, utils_1.getBadges)(nft, i18n);
        if (!nftBadges) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "dui-nft-card__badges" }, nftBadges.map(function (badge) { return renderBadge(badge); })));
    }, []);
    return (react_1.default.createElement(Card_1.Card, __assign({ className: (0, classnames_1.default)(className, 'dui-nft-card'), link: true, id: nft.id }, cardProps),
        react_1.default.createElement(NFTImage_1.NFTImage, { nft: nft, className: "dui-nft-card__image" }),
        react_1.default.createElement(Card_1.Card.Content, { className: "dui-nft-card__information" },
            renderHeader(),
            renderSubtitle(),
            renderBadges())));
};
exports.NFTCard = NFTCard;
exports.NFTCard.defaultProps = {
    i18n: {
        network: {
            ethereum: 'Ethereum',
            matic: 'Matic'
        },
        bodyShape: {
            male: 'Male',
            female: 'Female',
            unisex: 'Unisex'
        },
        playMode: {
            loop: 'Loop',
            once: 'Once'
        },
        category: {
            body_shape: 'Body Shape',
            earring: 'Earring',
            eyebrows: 'Eyebrows',
            eyes: 'Eyes',
            eyewear: 'Eyewear',
            facial_hair: 'Facial Hair',
            feet: 'Feet',
            head: 'Head',
            hair: 'Hair',
            hat: 'Hat',
            helmet: 'Helmet',
            lower_body: 'Lower Body',
            mask: 'Mask',
            mouth: 'Mouth',
            tiara: 'Tiara',
            top_head: 'Top Head',
            upper_body: 'Upper Body',
            skin: 'Skin',
            hands_wear: 'Handwear'
        },
        withSound: 'With sound',
        smart: 'Smart'
    }
};
